export default __webpack_public_path__ + "static/media/Latina_Logo2.9f98fc89.png";